import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_colapse",
  "use": "micro_colapse-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_colapse\"><path fill-rule=\"evenodd\" d=\"M1.938 8H.5L5 3l4.5 5H8.062L5 4.5 1.937 8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol